import { Tabs } from "ant-design-vue";
const { TabPane, ...other } = Tabs;

const YwTabs = {
  ...other,
  name: "YwTabs",
  TabPane: {
    ...TabPane,
    name: "YwTabPane",
  },
  TabContent: {
    ...Tabs.TabContent,
    name: "YwTabContent",
  },
};

YwTabs.install = function (Vue) {
  Vue.component(YwTabs.name, Tabs);
  Vue.component(YwTabs.TabPane.name, TabPane);
};

export default YwTabs;

